import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Common } from 'ws-scripts/modules/common';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';
import HighlightedFeatures from '../components/HighlightedFeatures';
import AllHighlightedFeatures from '../components/AllHighlightedFeatures';

export class WidgetContainer extends React.Component {
	componentDidMount() {
		setNewRelicCustomAttribute(
			'ws-hl-features-feature-count',
			this.props.features?.length
		);
	}

	render() {
		const featureArray = this.props.features;
		const featureCount = featureArray.length;
		let slicedFeatureArray = featureArray;
		let showAllFeatures = false;
		const rootComponent = (
			<Common
				render={({ prefs, flags }) => {
					if (featureCount > prefs.maxHighlightedFeatures) {
						slicedFeatureArray = featureArray.slice(
							0,
							prefs.maxHighlightedFeatures
						);
						showAllFeatures =
							flags['show-all-highlighted-features'];
					}
					return (
						<>
							<HighlightedFeatures
								features={slicedFeatureArray}
							/>
							{showAllFeatures && <AllHighlightedFeatures />}
						</>
					);
				}}
			/>
		);
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	features: PropTypes.arrayOf(PropTypes.string).isRequired
};

const mapStateToProps = (state) => {
	return {
		features: state.features
	};
};

const mapDispatchToProps = (_dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);
